<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">

    <AppHeader/>

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">

      <LeftMenu/>

      <template v-if="directoryService && directoryService.Status == 'ACTIVE'">

      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">


          <!-- begin::List -->
          <div class="row" id="DirectoryList">
            <div class="col-xl-12">

              <!--Begin::Portlet-->

              <div class="m-portlet m-portlet--rounded m-portlet--head-sm fullable-portlet"
                   :m-portlet="'true'" id="DirectoryPortlet">
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                                <span class="m-portlet__head-icon">
                                    <i class="flaticon-signs-1 m--font-brand m--icon-font-size-lg1 mt-n1"></i>
                                </span>
                      <h3 class="m-portlet__head-text">
                        {{ $t('Directory.manage')}}
                      </h3>
                    </div>
                  </div>
                  <div class="m-portlet__head-tools">
                    <ul class="m-portlet__nav">

                      <li class="m-portlet__nav-item">
                        <a href="javascript:"
                           :m-portlet-tool="'fullscreen'" data-trigger="hover"
                           class="m-portlet__nav-link m-portlet__nav-link--icon"><i class="la la-expand"></i></a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="m-portlet__body">

                  <!--begin::Table-->
                  <div class="table_sticky-header">
                    <table id="tableDirectories"
                           class="table m-table m-table--head-no-border table table-striped">
                      <thead>
                      <tr>
                        <th style="width:60px;" class="text-center">
                          <i class="flaticon-eye"></i>
                        </th>
                        <th style="width:55px;" class="text-left"></th>
                        <th style="width:200px;" class="text-left">{{ $t('Directory.table.Id')}} / {{ $t('Directory.table.Name')}}</th>
                        <th style="width:auto;" class="text-left"> {{ $t('Directory.table.Address')}}</th>
                        <th style="width:auto;" class="text-left">{{ $t('Directory.table.Category')}}
                        </th>
                        <th style="width:180px;" class="text-center">{{ $t('Directory.table.featured')}}</th>
                        <th style="width:100px;" class="text-left">{{ $t('Directory.table.actions')}}</th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr v-for="(directoryItem, index) in this.directories"
                          :key="directoryItem[index]"
                          :class="{'offline ':directoryItem.Online===false, 'm-table__row':true}"
                          data-offlinetxt="offline directory">
                        <td class="align-middle text-center m--hidden-mobile m--hidden-tablet">
                          <a :href="getRedirectURL(directoryItem.Id)" target="_blank"> <i class="flaticon-eye"></i> </a>
                        </td>
                        <td class="position-relative align-middle" data-thead-name="" style="display: table-cell; table-layout: fixed; text-align: center;">
                          <div v-if="directoryItem.Logo"
                                 class="thumbnailTable align-middle" style="display: table-cell; text-align: center; width:100%; height:100%;">
                            <img :src="directoryItem.Logo"
                                 alt=""
                                 style="width: 100%; height: auto; text-align: center;">
                          </div>
                          <div v-else class="d-inline-block">
                                  <span class="img-cont no-logo align-middle">
                                    <i class="la la-camera m--icon-font-size-lg3 d-block"></i>
                                    <span class="d-block small text-center">{{$t('common.nologo')}}</span>
                              </span>
                          </div>

                        </td>
                        <td class="align-middle" :data-thead-name="$t('Directory.table.Id')+' / '+ $t('Directory.table.Name')">
                          <a :href="getRedirectURL(directoryItem.Id)" target="_blank">{{directoryItem.Id}}</a><br>
                          {{directoryItem.Name}}

                        </td>
                        <td class="align-middle" :data-thead-name="$t('Directory.table.Address')">{{getAddress(directoryItem)}}</td>
                        <td class="align-middle" :data-thead-name="$t('Directory.table.Category')">{{ $t('Directory.subcategory.'+directoryItem.SubcategoryTerm)}}
                        </td>
                        <td class="align-middle text-center text-md-left" :data-thead-name="$t('Directory.table.featured')">

                          <template v-if="directoryItem.IsFeatured || directoryItem.IsPremiumFeatured">

                            <template v-if="directoryItem.IsFeatured && !directoryItem.IsPremiumFeatured">

                               <span class="m-switch m-switch--sm m-switch--icon m-switch--success d-block"
                                     v-if="directoryItem.IsFeatured">
                                <label class="mb-0">
                                  <input type="checkbox"
                                         disabled
                                         checked="checked" name="">
                                  <span class="m-switch--label">{{$t('homepage.services.Standard')}}&nbsp;</span>
                                </label>
                              </span>

                              <router-link v-if="!directoryItem.IsPremiumFeatured" :to="{ name: 'AdvertiseDir'}" class="activateService mt-2 d-block text-md-left">
                                {{$t('Directory.table.UpgradeToPremium')}}
                              </router-link>

                            </template>

                            <span v-if="directoryItem.IsPremiumFeatured" class="m-switch m-switch--sm m-switch--icon m-switch--primary d-block">
                              <label>
                                <input
                                  disabled
                                  @click="$event.preventDefault();$event.stopPropagation();"
                                  type="checkbox" checked="checked" name="">
                                <span class="m-switch--label">Premium</span>
                              </label>
                            </span>

                          </template>
                          <template v-else>
                            <router-link :to="{ name: 'AdvertiseDir'}" class="activateService mt-2 d-block text-sm-center">
                              {{$t('Directory.table.UpgradeToFeatured')}}
                            </router-link>
                          </template>

                        </td>

                        <td class="align-middle text-left position-relative actionBtnTd">

                          <div class="m-separator dark m-separator--dashed my-4 d-block d-lg-none d-xl-none"></div>

                          <template v-if="directoryItem.IsFeatured || directoryItem.IsPremiumFeatured">
                            <a href="javascript:" :id="'actionBtn'+directoryItem.Id"
                               class="m-portlet__nav-link m-dropdown__toggle btn m-btn m-btn--link" data-toggle="dropdown"
                               aria-haspopup="true" aria-expanded="true">
                              <i class="la la-ellipsis-h"></i>
                            </a>

                            <div class="dropdown-menu dropdown-menu-left m-dropdown__wrapper" :aria-labelledby="'actionBtn'+directoryItem.Id">
                              <div class="px-1">
                                <ul class="m-nav">
                                  <li class="m-nav__item">
                                    <a href="javascript:" class="btn btn-brand m-btn btn-block m-btn--wide btn-sm"
                                       @click.prevent="editDirectory(directoryItem)">
                                      {{$t('common.Edit')}}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </template>
                          <div class="text-center" v-else>
                            -
                          </div>
                        </td>
                      </tr>
                      <template v-if="directories.length === 0">
                        <tr>
                          <td colspan="11" class="text-center m--regular-font-size-lg3">
                            <template v-if="!loading">{{this.$t('Property.table.NoRecordsFound')}} {{directories.length}}</template>
                            <template v-else>{{this.$t('common.sendingDataPleaseWait')}}</template>
                          </td>
                        </tr>
                      </template>

                      </tbody>
                    </table>
                    <div class="m-separator m-separator--dashed mt-2"></div>
                  </div>
                  <!--end::Table-->

                </div>

              </div>

              <!--end: Portlet-->
            </div>
          </div>
          <!-- end::List -->

          <!-- BEGIN::MODAL EDIT -->
          <div class="modal fade" id="modalDirectoryEdit" tabindex="-1" role="dialog" aria-labelledby="modalDirectoryEdit"
                aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl m-portlet--fullscreen" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" v-html="`Edit ${(this.directory? this.directory.Name: '')}`"></h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-xl-12">

                      <!--begin: Form Wizard-->
                      <div class="m-wizard m-wizard--5 m-wizard--brand m-wizard--step-first" id="m_wizard"
                           v-bind:data-startStep="startTab">
                        <!--begin: Form Wizard Head -->
                        <div class="m-wizard__head">
                          <div class="row">
                            <div class="col-xl-12">

                              <!--begin: Form Wizard Nav -->
                              <div class="m-wizard__nav">
                                <div class="m-wizard__steps">
                                  <div class="m-wizard__step m-wizard__step--current"
                                       :m-wizard-target="'m_wizard_form_step_1'">
                                    <div class="m-wizard__step-info">
                                      <a href="javascript:" class="m-wizard__step-number">
                                        <span class="m-wizard__step-seq m--hidden-mobile">
                                            1.
                                        </span>
                                        <span class="m-wizard__step-label">
                                            {{$t('common.Details')}}
                                        </span>
                                        <span class="m-wizard__step-icon">
                                            <i class="la la-check"></i>
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                  <div class="m-wizard__step"
                                       :m-wizard-target="'m_wizard_form_step_2'">
                                    <div class="m-wizard__step-info">
                                      <a href="javascript:" class="m-wizard__step-number">
                                        <span class="m-wizard__step-seq m--hidden-mobile">
                                            2.
                                        </span>
                                        <span class="m-wizard__step-label">
                                            {{$t('common.Description')}}
                                        </span>
                                        <span class="m-wizard__step-icon">
                                            <i class="la la-check"></i>
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                  <div class="m-wizard__step"
                                       :m-wizard-target="'m_wizard_form_step_3'">
                                    <div class="m-wizard__step-info">
                                      <a href="javascript:" class="m-wizard__step-number">
                                        <span class="m-wizard__step-seq m--hidden-mobile">
                                            3.
                                        </span>
                                        <span class="m-wizard__step-label">
                                            Logo
                                        </span>
                                        <span class="m-wizard__step-icon">
                                            <i class="la la-check"></i>
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                  <div class="m-wizard__step"
                                       :m-wizard-target="'m_wizard_form_step_4'">
                                    <div class="m-wizard__step-info">
                                      <a href="javascript:" class="m-wizard__step-number">
                                        <span class="m-wizard__step-seq m--hidden-mobile">
                                            4.
                                        </span>
                                        <span class="m-wizard__step-label">
                                            {{$t('common.Confirmation')}}
                                        </span>
                                        <span class="m-wizard__step-icon">
                                            <i class="la la-check"></i>
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--end: Form Wizard Nav -->

                            </div>
                          </div>
                        </div>
                        <!--end: Form Wizard Head -->


                        <!--begin: Form Wizard Form-->
                        <div class="m-wizard__form">
                          <form class="m-form m-form--label-align-left- m-form--state-" id="m_form" novalidate="novalidate">

                            <div class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-danger fade show mt-4 mb-1"
                                 role="alert">
                              <div class="m-alert__icon">
                                <i class="flaticon-danger"></i>
                                <span></span>
                              </div>
                              <div class="m-alert__text">
                                <strong>{{ $t('Property.form.Attention')}}:</strong> {{$t('Property.ChangesSavedOnFinalStep')}}
                              </div>
                            </div>

                            <!--begin: Form Body -->
                            <div class="m-portlet__body">

                              <!--begin: Form Wizard Step 1-->
                              <div class="m-wizard__form-step m-wizard__form-step--current" id="m_wizard_form_step_1">
                                <div class="row">
                                  <div class="col-xl-12">

                                    <div class="m-form__section m-form__section--first">
                                      <div
                                        class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-brand alert-dismissible fade show mt-0"
                                        role="alert">
                                        <div class="m-alert__icon">
                                          <i class="flaticon-exclamation-1"></i>
                                          <span></span>
                                        </div>
                                        <div class="m-alert__text">
                                          <strong>{{ $t('Property.form.Note')}}:</strong> {{$t('Directory.SomeFieldsAreNotEditable')}}
                                          <router-link :to="{ name: 'Support'}" active-class="active" class="m-nav__link-text">
                                            <strong>{{$t('common.ContactUs')}}</strong>
                                          </router-link>
                                          .
                                        </div>
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                        </button>
                                      </div>

                                      <input type="hidden" v-if="directory.Id" name="Id" :value="directory.Id" id="directoryID">

                                      <div class="row">
                                        <div class="col-xll-2 col-xl-2 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label class="col-xl-12 col-form-label" for="DirName">
                                              {{$t('Directory.table.Name')}}: <small>(*)</small>
                                            </label>
                                            <div class="col-xl-12">

                                              <input type="text" id="DirName" readonly
                                                     class="form-control m-input m-input--solid"
                                                     :placeholder="$t('Property.Enquiries.placeholder.name')"
                                                     :value="directory.Name || null">
                                            </div>
                                          </div>
                                        </div>

                                        <div class="col-xll-2 col-xl-2 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label class="col-xl-12 col-form-label" for="DirEmail">
                                              Email:
                                            </label>
                                            <div class="col-xl-12">
                                              <input type="text"
                                                     id="DirEmail"
                                                     readonly
                                                     class="form-control m-input m-input--solid"
                                                     :placeholder="$t('Property.Enquiries.placeholder.email')"
                                                     :value="directory.Email || null">
                                            </div>
                                          </div>
                                        </div>

                                        <div class="col-xll-2 col-xl-2 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label class="col-xl-12 col-form-label" for="DirPhone">
                                              {{$t('Property.Enquiries.Telephone')}}:
                                            </label>
                                            <div class="col-xl-12">
                                              <input type="text"
                                                     id="DirPhone"
                                                     readonly
                                                     class="form-control m-input m-input--solid"
                                                     :placeholder="$t('Directory.table.Telephone')"
                                                     :value="directory.Phone || null">
                                            </div>
                                          </div>
                                        </div>

                                        <div class="col-xll-2 col-xl-2 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label class="col-xl-12 col-form-label" for="DirMobile">
                                              {{$t('Directory.table.Mobile')}}:
                                            </label>
                                            <div class="col-xl-12">
                                              <input type="text" id="DirMobile" readonly
                                                     class="form-control m-input m-input--solid"
                                                     :placeholder="$t('Directory.table.Mobile')"
                                                     :value="directory.Mobile || null">
                                            </div>
                                          </div>
                                        </div>

                                        <div class="col-xll-2 col-xl-2 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label class="col-xl-12 col-form-label" for="DirFax">
                                              Fax:
                                            </label>
                                            <div class="col-xl-12">
                                              <input type="text" id="DirFax" readonly
                                                     class="form-control m-input m-input--solid"
                                                     :placeholder="$t('Directory.table.Fax')"
                                                     :value="directory.Fax || null">
                                            </div>
                                          </div>
                                        </div>

                                        <div class="col-xll-2 col-xl-2 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label class="col-xl-12 col-form-label" for="DirURL">
                                              URL:
                                            </label>
                                            <div class="col-xl-12">
                                              <input type="text" name="URL" id="DirURL" readonly
                                                     class="form-control m-input m-input--solid"
                                                     placeholder="URL"
                                                     :value="directory.URL || null">

                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="m-separator--dashed m-separator mb-3 m-separator--md"></div>

                                      <div class="row">
                                        <div class="col-xll-7 col-xl-7 col-md-5 col-sm-12 col-xs-12">
                                          <div class=" row ">
                                            <label class="col-xl-12 col-form-label">
                                              {{ $t('Property.form.FullAddress.label')}}:
                                            </label>
                                            <div class="col-xl-12">
                                              <input type="text"
                                                     class="form-control m-input m-input--solid"
                                                     id="Address"
                                                     readonly
                                                     :value="directory.Address">
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-xll-1 col-xl-2 col-md-4 col-sm-12">
                                          <div class="row">
                                            <label class="col-xl-12 col-form-label" for="DirZipCode">
                                              {{$t('Directory.table.ZipCode')}}:
                                            </label>
                                            <div class="col-xl-12">
                                              <input type="text" id="DirZipCode"
                                                     readonly
                                                     class="form-control m-input m-input--solid"
                                                     :placeholder="$t('Directory.table.ZipCode')"
                                                     :value="directory.ZipCode || null">
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-xll-3 col-xl-3 col-md-5 col-sm-12 col-xs-12">
                                          <div class="row ">
                                            <label class="col-xl-12 col-form-label">
                                              {{ $t('Property.form.Location')}}:
                                            </label>
                                            <div class="col-xl-12">

                                              <div class="input-group">
                                                <input type="text"
                                                       :value="getTownDisplayName(directory)"
                                                       id="Location"
                                                       class=" nosearch form-control m-input m-input--solid"
                                                       readonly>
                                                <span></span>

                                                <div class="input-group-append">
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="m-separator--dashed m-separator mb-3 m-separator--md"></div>

                                      <div class="row">
                                        <div class="col-xl-4 col-md-12 col-sm-12">
                                          <div class="row">
                                            <div class="col-xl-12">
                                              <div class=" row ">
                                                <label class="col-xl-12 col-form-label">
                                                  {{ $t('Property.form.Coordinates.label')}}:
                                                </label>
                                                <div class="col-xl-6 col-sm-6">

                                                  <div class="input-group form-group">
                                                    <div class="input-group-prepend">
                                                      <span
                                                        class="input-group-text"><small>{{ $t('Property.form.Coordinates.latitude.shortlabel')}}</small></span>
                                                    </div>
                                                    <input
                                                      :readonly="!positionEdition"
                                                      name="Latitude"
                                                      class="form-control m-input m-input--solid"
                                                      :placeholder="$t('Property.form.Coordinates.latitude.placeholder')"
                                                      v-model.number="directory.Latitude">
                                                  </div>
                                                </div>
                                                <div class="col-xl-6 col-sm-6">
                                                  <div class="input-group form-group">
                                                    <div class="input-group-prepend">
                                                      <span class="input-group-text"><small>{{ $t('Property.form.Coordinates.longitude.shortlabel')}}</small></span>
                                                    </div>
                                                    <input
                                                      :readonly="!positionEdition"
                                                      name="Longitude"
                                                      class="form-control m-input m-input--solid"
                                                      :placeholder="$t('Property.form.Coordinates.longitude.placeholder')"
                                                      v-model.number="directory.Longitude">
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div class="col-xl-12">

                                              <button type="button" class="btn btn-brand btn-sm mb-1" :disabled="!directory.Address"
                                                      @click="getLatLngFromAddress">
                                                <i class="la la-map-marker"></i> {{ $t('Property.form.coordinateButtons.useAddressField')}}
                                              </button>
                                              <button type="button" class="btn btn-brand btn-sm mb-1" @click="getCurrentLocation($event)">
                                                <i class="la la-map-marker"></i> {{ $t('Property.form.coordinateButtons.useMyLocation')}}
                                              </button>
                                              <button type="button" class="btn btn-brand btn-sm mb-1" @click="toggleAddEdit">
                                              <i class="la la-map-marker"></i> {{ $t("Property.form.coordinateButtons.addEdit") }}
                                            </button>
                                              <button type="button" class="btn btn-danger btn-sm mb-1" @click="clearCoord">
                                                <i class="la la-map-marker"></i> {{ $t('Property.form.coordinateButtons.clear')}}
                                              </button>
                                            </div>

                                          </div>
                                        </div>


                                        <div class="col-xl col-md-12 col-sm-12">

                                          <label class="col-xl-12 col-form-label m--hidden-tablet-and-mobile">

                                          </label>

                                          <template v-if="directory.Latitude && directory.Longitude">
                                            <gmap-map
                                              ref="myMap"
                                              :center="position"
                                              :zoom="17"
                                              :options="gMapOptions"
                                              style="width:100%;  height: 300px;">
                                              <gmap-marker
                                                v-if="position"
                                                :position="position"
                                                @click="center=position"
                                                :options="gPinOptions"
                                                @dragend="positionMoved">
                                              </gmap-marker>
                                            </gmap-map>

                                            <div class="col-xl-12 mt-2">
                                              <span class="m-form__help">
                                                  <i class="la la-map-marker"></i> {{$t('Property.form.map.helptext')}}
                                              </span>
                                            </div>

                                          </template>

                                          <template v-else>
                                            <div class="row">
                                              <div class="col-xl-12">
                                                <div class="col-xl-12 m-stack m-stack--ver m-stack--general px-0">
                                                  <div class="col-xl-12 card text-center m-stack__item m-stack__item--center m-stack__item--middle"
                                                       style="height:300px">

                                                    <label
                                                      class="col-xl-12 col-form-label m-stack__item m-stack__item--center m-stack__item--middle">
                                                      <i class="la la-map m--icon-font-size-lg2 d-block"></i> {{$t('Property.form.map.helptext2')}}
                                                    </label>

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </template>

                                        </div>

                                      </div>

                                      <div class="m-separator--dashed m-separator mb-3 m-separator--md"></div>

                                      <div
                                        class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-brand alert-dismissible fade show mt-4"
                                        role="alert">
                                        <div class="m-alert__icon">
                                          <i class="flaticon-exclamation-1"></i>
                                          <span></span>
                                        </div>
                                        <div class="m-alert__text">
                                          <strong>{{ $t('Property.form.Note')}}:</strong> {{$t('Directory.SelectLanguages')}}
                                        </div>
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                        </button>
                                      </div>

                                      <div class="row" v-if="directory.Languages">

                                        <label class="col-xl-12 col-form-label" for="DirURL">
                                          {{$t('Directory.form.SpokenLanguages')}}:
                                        </label>
                                        <div class="col-6 col-lg-2 pt-xl-2 pt-lg-2 pt-md-2 pt-sm-2 pt-xs-2 pt-2" v-for="(language, index) in languages" :key="index">
                                          <label class="m-checkbox m-checkbox--solid m-checkbox--brand">
                                            <input type="checkbox" v-model="directory.Languages" :value="language.code">
                                            {{$t('language.' + language.code)}}
                                            <span></span>
                                          </label>
                                        </div>
                                      </div>
                                      <div class="m-separator--dashed m-separator mb-2 m-separator--md"></div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              <!--end: Form Wizard Step 1-->



                              <!--begin: Form Wizard Step 2-->
                              <div class="m-wizard__form-step" id="m_wizard_form_step_2">
                                <div class="row">
                                  <div class="col-xl-12">
                                    <ul class="ts-checktags">
                                    <li
                                      v-for="(language, index) in languages"
                                      :key="index"
                                    >
                                      <input
                                        :id="'language-' + language.code"
                                        type="checkbox"
                                        :checked="languageInEdit == language.code"
                                        @click="languageInEdit = language.code"
                                      />
                                      <label
                                        :for="'language-' + language.code"
                                        class="ts-checktags-label"
                                        >
                                          <svg v-if="!directory.Text[language.code]"  style="float: left; margin-right: 5px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" class="statusDesc">
                                            <circle fill="none" property.Desc="" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" class="path circle show"></circle>
                                            <line fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" class="path line show"></line> <line fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" class="path line show"></line>
                                          </svg>
                                          <svg v-else  style="float: left; margin-right: 5px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" class="statusDesc"><circle fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" class="path circle show"></circle> <polyline fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " class="path check show"></polyline></svg>
                                        {{ $t('language.' + language.code) }}</label
                                      >
                                    </li>
                                  </ul>
                                  <div class="form-group row m-form__group" >
                                    <div class="col-xl-12 px-0 pt-2">
                                      <div class="col-xl-12 px-1" v-for="(language, index) in languages" :key="index">
                                        <template v-if="languageInEdit == language.code">
                                        <h3 class="m-portlet__head-text">{{ $t('language.' + language.code) }}</h3>
                                        <textarea
                                          rows="10"
                                          class="form-control m-input m-input--solid mb-2"
                                          v-model="directory.Text[language.code]"
                                          :placeholder="
                                            $t(
                                              'common.PleaseEnterADescription',
                                              {
                                                language: $t(
                                                  'language.' +
                                                    language.code
                                                ),
                                              }
                                            )
                                          "
                                          :name="language.code"
                                        ></textarea>
                                        </template>
                                      </div>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                              </div>
                              <!--!!::end: Form Wizard Step 2-->



                              <!--begin: Form Wizard Step 3-->
                              <div class="m-wizard__form-step" id="m_wizard_form_step_3">
                                <div class="row">
                                  <div class="col-xl-12">

                                    <div class="row ui-sortable" id="m_sortable_portlets">

                                      <div class="col-lg">
                                        <div class="m-portlet  m-portlet--head-sm">
                                          <div class="m-portlet__head">
                                            <div class="m-portlet__head-caption">
                                              <div class="m-portlet__head-title">
                                                <span class="m-portlet__head-icon m--hide">
                                                    <i class="la la-gear"></i>
                                                </span>
                                                <h3 class="m-portlet__head-text">
                                                  Logo
                                                </h3>
                                              </div>
                                            </div>
                                          </div>
                                          <!--begin::Form-->
                                          <form enctype='multipart/form-data'>
                                            <div class="m-portlet__body">

                                              <div class=" m-form__group">
                                                <div class="alert m-alert alert-info m-alert--outline mb-4" role="alert">
                                                  {{$t('common.maxfilesize')}}.
                                                </div>
                                                <div class="row">
                                                  <div class="col-lg-12">
                                                    <div class="custom-file">
                                                      <input type="file" class="custom-file-input" id="file" :model="directory.Logo"
                                                             @change="onFileChange" accept="image/*">
                                                      <label class="custom-file-label" for="file"> {{$t('common.chooseFile')}}</label>
                                                    </div>
                                                  </div>
                                                </div>


                                              </div>
                                            </div>
                                            <div class="m-portlet__foot m-portlet__foot--fit">
                                              <div class="m-form__actions">
                                                <div class="m-form__group mt-n4">
                                                  <div class="row" v-if="directory.Logo">
                                                    <div class="col-lg-12 pb-3 text-center pt-4">
                                                      <img
                                                        alt=""
                                                        :src="directory.Logo" width="auto" style="max-width:100%; min-height: 70px;"/>
                                                      <div class="clearfix mt-3"></div>
                                                      <a href="javascript:"
                                                         class="m-btn btn-block m-btn--hover-danger m-btn--pill btn btn-secondary ws-nowrap"
                                                         @click.prevent="deleteImage()"><i class="la la-trash"></i> {{$t('common.Delete')}}</a>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="clearfix"></div>
                                              </div>
                                            </div>
                                          </form>
                                          <!--end::Form-->
                                        </div>
                                      </div>

                                      <div class="col-lg-8">

                                        <!--begin::Portlet-->

                                        <div class="m-portlet m-portlet--mobile m-portlet--sortable m-portlet--head-sm photo-item" v-if="directory.Logo">

                                          <div class="m-portlet__head ui-sortable-handle text-overflow">
                                            <div class="m-portlet__head-caption">
                                              <div class="m-portlet__head-title">
                                                <span class="m-portlet__head-icon">
                                                    <i class="la la-photo m--font-brand"></i>
                                                </span>
                                                <h3 class="m-portlet__head-text m--font-brand m--hidden-mobile m--hidden-tablet">
                                                  {{ directory.Logo }}
                                                </h3>
                                              </div>
                                            </div>
                                            <div class="m-portlet__head-tools">
                                              <div class="counter"></div>
                                            </div>
                                          </div>
                                          <div class="m-portlet__body">
                                            <div class="tab-pane active">
                                              <div class="m-widget4 m-widget4--progress text-center">
                                                <img
                                                  alt=""
                                                  :src="directory.Logo" width="auto" style="max-width:100%; min-height: 70px;"/>
                                                <div class="clearfix mt-3"></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>


                                        <!--end::Portlet-->
                                        <div v-else class="m-stack m-stack--ver m-stack--general">
                                          <h4 class="m-stack__item m-stack__item--center m-stack__item--middle">
                                            <i class="la la-camera m--icon-font-size-lg5"></i>
                                            <span class="d-block">{{$t('common.nologouploadedyet')}}</span>
                                          </h4>
                                        </div>


                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              <!--!!::end: Form Wizard Step 3-->



                              <!--begin: Form Wizard Step 4-->
                              <div class="m-wizard__form-step" id="m_wizard_form_step_4">
                                <div class="row">
                                  <div class="col-xl-12">
                                    <div class="row">

                                      <div class="col-lg-4">
                                        <div class="m-form__section">
                                          <div class="m-form__heading">
                                            <h3 class="m-form__heading-title">
                                              {{$t('common.Details')}} <a href="javascript:" @click="clickEditTab(1)"><i class="la la-pencil"></i></a>
                                            </h3>
                                          </div>
                                          <div class="form-group m-form__group row">
                                            <div class="col-lg-12">
                                              <ul class="m-nav">
                                                <li class="m-nav__item">
                                                  <label class="m--font-boldest">
                                                    <strong>{{directory.Name}}</strong>
                                                  </label>
                                                </li>
                                                <li class="m-nav__item" v-if="directory.Phone != null && directory.Phone !== ''">
                                                  <label class="m--font-boldest">
                                                    <strong><i class="la la-phone"></i> {{directory.Phone}}</strong>
                                                  </label>
                                                </li>
                                                <li class="m-nav__item" v-if="directory.Mobile != null && directory.Mobile !== ''">
                                                  <label class="m--font-boldest">
                                                    <strong><i class="la la-mobile"></i> {{directory.Mobile}}</strong>
                                                  </label>
                                                </li>
                                                <li class="m-nav__item" v-if="directory.Fax != null && directory.Fax !== ''">
                                                  <label class="m--font-boldest">
                                                    <strong><i class="la la-fax"></i> {{directory.Fax}}</strong>
                                                  </label>
                                                </li>
                                                <li class="m-nav__item" v-if="directory.URL != null && directory.URL !== ''">
                                                  <label class="m--font-boldest">
                                                    <strong><i class="la la-globe"></i> {{directory.URL}}</strong>
                                                  </label>
                                                </li>
                                                <li class="m-nav__item">
                                                  <label class="m--font-boldest">
                                                    <strong>
                                                      <i class="la la-location-arrow"></i>
                                                      {{getAddress(directory)}}, <span v-if="directory.Location">{{directory.Location}}</span>
                                                    </strong>
                                                  </label>
                                                </li>

                                                <li class="m-nav__item" v-if="directory.Latitude && directory.Longitude">
                                                  <label class="m--font-boldest">
                                                    <strong>
                                                      <i class="la la-map-marker"></i> {{directory.Latitude}}, {{directory.Longitude}}
                                                    </strong>
                                                  </label>
                                                </li>
                                              </ul>
                                            </div>

                                          </div>
                                        </div>

                                      </div>

                                      <div class="col-lg-2">
                                        <div class="row">
                                          <div class="m-form__section m-form__section--first col">
                                            <div class="m-form__heading">
                                              <h3 class="m-form__heading-title">
                                                Logo <a href="javascript:" @click="clickEditTab(3)"><i class="la la-pencil"></i></a>
                                              </h3>
                                            </div>
                                            <div class="form-group m-form__group row">

                                              <div v-if="!directory.Logo" class="col-xl col-lg-4 col-md-4 col-sm-6 col-xs-12 col mb-3">

                                                <div class="mt-4 m-alert m-alert--outline alert alert-danger fade show" role="alert">
                                                  <strong>{{$t('common.nologouploaded')}}</strong><br>{{$t('common.PleaseUploadLogoToGetBetterResults')}}
                                                </div>
                                              </div>

                                              <div class="pl-3 mb-3 ">
                                                <img
                                                  alt=""
                                                  :src="directory.Logo" style="max-width: 200px">
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="col-lg-4">
                                        <div class="m-form__section">
                                          <div class="m-form__heading">
                                            <h3 class="m-form__heading-title">
                                              {{$t('Directory.form.SpokenLanguages')}} <a href="javascript:" @click="clickEditTab(1)"><i
                                              class="la la-pencil"></i></a>
                                            </h3>
                                          </div>
                                          <div class="form-group row">
                                            <div class="col-lg-12">
                                              <ul class="m-nav">
                                                <li class="m-nav__item">
                                                  <label class="m--font-boldest" v-for="(language, key) in directory.Languages" :key="language[key]">
                                                    <strong>{{ $t('language.' + language) }}</strong><span v-if="key < directory.Languages.length - 1">,</span>
                                                    &nbsp;
                                                  </label>
                                                </li>


                                              </ul>
                                            </div>

                                          </div>
                                        </div>
                                      </div>

                                    </div>


                                    <div class="row">
                                      <div class="col">
                                        <div class="col-lg m-separator m-separator--dashed m-separator--lg"></div>
                                      </div>
                                    </div>


                                    <div class="row">
                                      <div class="col-lg-12">
                                        <div class="m-form__section m-form__section">
                                          <div class="m-form__heading">
                                            <h3 class="m-form__heading-title">
                                              {{$t('Property.form.Descriptions')}} <a href="javascript:" @click="clickEditTab(2)"><i
                                              class="la la-pencil"></i></a>
                                            </h3>
                                          </div>
                                          <div class="form-group m-form__group row pt-0">

                                            <div class="col-lg-12">
                                              <div class="m-portlet m-portlet--tabs m-portlet--unair m-portlet--head-sm mb-0">
                                                <div class="m-portlet__body pl-1 pt-3 pb-0">
                                                  <div class="row">

                                                    <div v-for="(language, index) in languages"
                                                         :key="language[index]"
                                                         class="col-lg-6 col-12 col-md-12 col-xs-12 mb-4">
                                                      <h6 class="mb-4">{{$t('language.'+language.code)}} <small>[{{language.code}}]</small></h6>

                                                        <span v-if='!checkHasDesc(language.code)' class="my-2 d-block m-alert m-alert--outline alert alert-danger fade show" role="alert"
                                                              v-html="$t('Property.form.noDescFilledIn', {language: $t('language.'+language.code)})">
                                                        </span>
                                                        <span v-else v-html="directory.Text[language.code]">
                                                        </span>
                                                    </div>

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col">
                                        <div class="col-lg m-separator m-separator--dashed m-separator--lg"></div>
                                      </div>
                                    </div>

                                    <div class="m-separator m-separator--dashed m-separator--lg"></div>
                                  </div>
                                </div>
                              </div>
                              <!--end: Form Wizard Step 4-->

                            </div>
                            <!--end: Form Body -->

                            <!--begin: Form Actions -->
                            <div class="m-portlet__foot m-portlet__foot--fit">
                              <div class="m-form__actions m-form__actions px-3">
                                <div class="row">


                                  <div class="col px-0">
                                    <a href="javascript:" class="mb-3 btn btn-secondary m-btn m-btn--custom m-btn--icon btn-block-sm"
                                       data-wizard-action="prev">
                                        <span>
                                            <i class="la la-arrow-left"></i>
                                            <span>
                                                {{$t('common.Back')}}
                                            </span>
                                        </span>
                                    </a>
                                    <div class="pull-right">
                                      <a href="javascript:" class="btn btn-brand m-btn m-btn--custom m-btn--icon btn-block-sm"
                                         data-wizard-action="submit" @click.prevent="confirmSaveDirectory">
                                          <span>
                                              <i class="la la-check"></i>
                                              <span>
                                                  {{$t('common.save')}}
                                              </span>
                                          </span>
                                      </a>

                                    </div>
                                    <a href="javascript:" class="pull-right btn btn-warning m-btn m-btn--custom m-btn--icon btn-block-sm"
                                       data-wizard-action="next">
                                        <span>
                                            <span v-if="step < 4">
                                                <span>
                                                    {{$t('common.Next')}}
                                                </span>
                                            </span>
                                        </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!--end: Form Actions -->
                          </form>
                        </div>
                        <!--end: Form Wizard Form-->


                      </div>
                      <!--end: Form Wizard-->

                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('common.Cancel')}}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- END::MODAL EDIT-->

        </div>

      </div>
      </template>
      <template v-if="directoryService && directoryService.Status != 'ACTIVE' ">
        <NoDirectoryServices></NoDirectoryServices>
      </template>
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter/>
    <!-- END: Footer -->
  </div>
</template>

<script>

  import AppHeader from '@/components/dashboard/common/Header'
  import AppFooter from '@/components/dashboard/common/Footer'
  import LeftMenu from '@/components/dashboard/common/menus/LeftMenu'

  import NoDirectoryServices from '@/components/dashboard/services/Directory'

  import vSelect from 'vue-select'
  import locationapi from '@/interceptors/locationapi'
  import {clientapi} from '@/interceptors/clientapi'

  import Cookie from 'js-cookie'
  import data from "@/plugins/data";
  import axios from 'axios'

  import functions from "@/plugins/functions";
  export default {
    data() {
      return {
        user: {},
        directoryService: null,
        townMap: {},
        startTab: 1,
        loading: false,
        positionEdition: false,
        directories: [],
        directory: {
          Id: null,
          Text: {
            da: null,
            de: null,
            en: null,
            es: null,
            fi: null,
            fr: null,
            it: null,
            nl: null,
            no: null,
            pl: null,
            pt: null,
            ru: null,
            sv: null
          },
          ServiceID: null,
          Logo: "",
          Location: null,
          Login: null,
          Name: null,
          Address: null,
          ZipCode: null,
          Phone: null,
          Mobile: null,
          Fax: null,
          URL: null,
          Email: null,
          Languages: [],
          CategoryID: null,
          CategoryName: "",
          SubcategoryID: null,
          SubcategoryName: "",
          Town: null,
          Province: null,
          Region: null,
          Country: null,
          Latitude: null,
          Longitude: null,
          IsFeatured: false,
          IsPremiumFeatured: false,
        },
        directoryCopy: null,
        languageInEdit: 'en',
        //table
        ts_url: process.env.TS_URL,
        //add
        validated: false,
        editId: null,
        step: 1,
        //step1
        saw: false,
        description: '',
        gMapOptions: {
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false,
          styles: [
            {
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "featureType": "administrative.land_parcel",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#bdbdbd"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#ffffff"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#dadada"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "transit.line",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "transit.station",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#dfe0e4"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            }
          ]
        },
        gPinOptions: {
          draggable: true,
          icon: 'https://unpkg.com/leaflet@1.3.4/dist/images/marker-icon.png',
        },
        //step2
        languages: [],
        trans: {},
      };
    },
    components: {
      AppFooter,
      AppHeader,
      LeftMenu,
      NoDirectoryServices,
      vSelect
    },
    async mounted() {
      let byName = function(c1, c2) {
        var name1 = c1.name.toUpperCase();
        var name2 = c2.name.toUpperCase();
        if (name1 < name2) {
          return -1;
        }
        if (name1 > name2) {
          return 1;
        }
        return 0;
      };
      let lang = this.userLang ? this.userLang : 'en'
      let listOfLanguages  = data.languages().map(language => { return { code: language.code, name: language.Labels[lang]}}).sort(byName)
      this.languages = listOfLanguages
      this.user = functions.getUser()
      this.directoryService = await functions.getDirectoryService()

      if (this.directoryService.Status != 'ACTIVE') {
        return
      }
      //edit
      WizardForm.init();
      $('#modalDirectoryEdit').modal('show')
      this.loadDirectories()
    },
    beforeRouteLeave (to, from, next) {
      this.closeModal()
      next()
    },
    beforeDestroy(){
      this.closeModal()
    },
    computed: {
      position: {
        get: function () {
          if (this.directory.Latitude && this.directory.Longitude) {
            return { lat: this.directory.Latitude, lng: this.directory.Longitude }
          }
          return null
        },
        // setter
        set: function (newValue) {
          this.directory.Latitude = newValue.lat
          this.directory.Longitude = newValue.lng
        }
      },
      userLang() {
        return Cookie.get('locale')
      },
    },
    methods: {
      getTownDisplayName(directory){
        if (!directory.Town)
          return ''

        let town = this.townMap[directory.Town]

        if (!town) {
          return ''
        }

        return town.Labels.Default + ', '+ town.Labels.province.Default
      },
      toggleAddEdit() {
        this.positionEdition = !this.positionEdition;
      },
      getAddress(directory){
        if (!directory.Town)
          return directory.Address + (directory.ZipCode && directory.ZipCode.length > 1 ? ', ' + directory.ZipCode : '')

        let town = this.townMap[directory.Town]

        if (!town) {
          return directory.Address + (directory.ZipCode && directory.ZipCode.length > 1 ? ', ' + directory.ZipCode : '')
        }

        return directory.Address + (directory.ZipCode && directory.ZipCode.length > 1 ? ', ' + directory.ZipCode : '') + ", " + town.Labels.Default + ', '+ town.Labels.province.Default
      },
      async loadDirectories(){
        this.directories = []
        this.loading = true
        mApp.block("body", {message: this.$t('common.LoadingDataPleaseWait')});

        let result = await clientapi.get('/directory')

        if (result.status != 200){
          let errorCode = result.data.code
          swal({
            title: this.$t('error.AnErrorOccurred'),
            text: this.$t('error.server.'+errorCode),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })

          this.directories = []
          this.loading = false
          mApp.unblock("body")
          return
        }

        if (result.data.length == 0){
          this.directories = []
          this.loading = false
          mApp.unblock("body")
          return
        }

        //loading all the towns
        //that would ever be necessary
        let townIds = result.data.filter(d => d.Town).map(d => d.Town)

        let townsCall = await locationapi.get('/town?' +  townIds.map(t => `Id=${t}`).join('&') )

        if (townsCall.status != 200){
          let errorCode = townsCall.data.code
          swal({
            title: this.$t('error.AnErrorOccurred'),
            text: this.$t('error.server.'+errorCode),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })

          this.directories = []
          mApp.unblock("body")
          this.loading = false
          return
        }

        for (let town of townsCall.data) {
          this.townMap[town.Id] = town
        }

        this.directories = result.data

        mApp.unblock("body")
        this.loading = false
      },
      //table
      getRedirectURL(id) {
        let lang_help = '';

        if (this.userLang !== 'en') {
          lang_help = '/' + this.userLang
        }

        return this.ts_url + lang_help + '/spain-listings/o' + id
      },
      editDirectory(directory) {
        WizardForm.init()
        WizardForm.r.goFirst();
        this.directory = JSON.parse(JSON.stringify(directory));

        //replace br for descriptions
        for (let lang in this.directory.Text){
          this.directory.Text[lang] = this.directory.Text[lang].replace(/<br\s?\/?>/g, '\n').replace(/\n\s*\n\s*\n/g, '\n\n')
        }
        $('#modalDirectoryEdit').modal('show')
      },
      closeModal() {
        $('#modalDirectoryEdit').modal('hide')
      },
      async confirmSaveDirectory() {

        mApp.block('.modal-dialog', {message: 'Sending data. Please wait...'})
        let directory = this.directory
        let putData = {
          "Id": directory.Id,
          "ServiceID": directory.ServiceID,
          "Logo": directory.Logo,
          "Login": directory.Login,
          "Languages": directory.Languages,
          "Latitude": directory.Latitude,
          "Longitude": directory.Longitude,
          "Text": directory.Text,
        };

        let result = await clientapi.put(`/directory/${directory.Id}/service/${directory.ServiceID}`, putData)

        if (result.status === 200) {
          swal({
            title: this.$t('Directory.DirectoryEdited.title'),
            text: this.$t('Directory.DirectoryEdited.message'),
            type: "success",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          }).then(() => {
            this.closeModal();
          })
        }else{
          let errorCode = result.data.code
          swal({
            title: this.$t('error.AnErrorOccurred'),
            text: this.$t('error.server.'+errorCode),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
        }

        mApp.unblock('.modal-dialog')

        this.loadDirectories()

      },
      clearCoord() {
        this.directory.Latitude = null
        this.directory.Longitude = null
      },
      async getLatLngFromAddress(event) {
        mApp.block(event.target);

        //this will make sure google plugin is loaded
        await this.$gmapApiPromiseLazy()
        let geocoder = new google.maps.Geocoder;

        let address = this.getAddress(this.directory)

        await geocoder.geocode({'address': address}, (results, status) => {
          mApp.unblock(event.target);
          if (status != 'OK' || results.length == 0) {
            swal({
              title: this.$t('Dashboard.noresults'),
              text: this.$t('Directory.ThereWhereNoResultsFoundWithTheProvidedFullAddress'),
              type: "error",
              confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
              onBeforeOpen: () => { functions.onBeforeOpenSwal() }
            });
          }

          let result = results[0]

          this.directory.Latitude = result.geometry.location.lat()
          this.directory.Longitude = result.geometry.location.lng()
        })
      },
      async positionMoved(marker) {

        let confirm = await swal({
          title: this.$t('common.areyousure'),
          text: this.$t('Directory.YouAreAboutToChangeLatitudeAndLongitudeOfTheOutlet'),
          showCancelButton: !0,
          confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
          confirmButtonText: this.$t('Directory.YesDoIt'),
          cancelButtonText: this.$t('common.Cancel'),
          type: "warning",
          onBeforeOpen: () => { functions.onBeforeOpenSwal() }
        })

        if (!confirm.value) {
          return
        }

        this.directory.Latitude = marker.latLng.lat()
        this.directory.Longitude = marker.latLng.lng()
      },
      getCurrentLocation(event) {
        if (!navigator.geolocation) {
          return
        }

        mApp.block(event.target);

        let component = this

        let success = function (position) {
          component.directory.Latitude = position.coords.latitude
          component.directory.Longitude = position.coords.longitude
        }

        let error = function() {
          swal({
            title: component.$t('Directory.MissingCoordenates'),
            text: component.$t('Directory.WeCouldntGeolcateYou'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          });
        }

        navigator.geolocation.getCurrentPosition(success, error)

        mApp.unblock(event.target)

      },
      //step3
      async deleteImage() {

        let confirm = await swal({
          title: this.$t('common.areyousure'),
          text: this.$t('Directory.logoWasDeletedSuccess.confirm'),
          showCancelButton: !0,
          confirmButtonClass: 'btn btn-brand m-btn m-btn--custom',
          confirmButtonText: this.$t('common.yesRemoveIt'),
          cancelButtonText: this.$t('common.Cancel'),
          type: "warning",
          onBeforeOpen: () => { functions.onBeforeOpenSwal() }
        })

        if (!confirm.value) {
          return
        }

        this.directory.Logo = null

        await swal({
          title: this.$t('Directory.logoWasDeletedSuccess.title'),
          text: this.$t('Directory.logoWasDeletedSuccess.message'),
          type: "success",
          confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
          onBeforeOpen: () => { functions.onBeforeOpenSwal() }
        });

      },
      async onFileChange(e) {
        let files = e.target.files

        //no files, nothing to do
        if (files.length == 0)
          return;

        //just single file is to be uploaded anyway....
        let img = files[0]
        if (!['image/png','image/jpeg'].includes(img.type)){
          swal({
            title: this.$t('common.FormatNotAllowed'),
            text: this.$t('common.FormatNotAllowedImg'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          });
          return;
        }

        if (img.size > 1024000) {
          swal({
            title: this.$t('common.sizeToBig'),
            text: this.$t('common.sizeToBigFile'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          });
          return;
        }

        //getting pre-signed url
        let body = {
          "ContentType": img.type,
          "Size": img.size,
          "Name": img.name
        }

        let presignedRequest = await clientapi.post(`/directory/${this.directory.Id}/service/${this.directory.ServiceID}/upload`, body)
        if (presignedRequest.status != 200){
          await swal({
                title: this.$t('error.ServerError400Image.title'),
                text: this.$t('error.ServerError400Image.text'),
                type: "error",
                confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
                onBeforeOpen: () => { functions.onBeforeOpenSwal() }
              });
          return
        }

        let uploadFile = await axios.put(presignedRequest.data.FileUploadURL, img, {headers: {"content-type": img.type, "x-amz-acl": "public-read" }})

        if (uploadFile.status != 200) {
          await swal({
                title: this.$t('error.ServerError400Image.title'),
                text: this.$t('error.ServerError400Image.text'),
                type: "error",
                confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
                onBeforeOpen: () => { functions.onBeforeOpenSwal() }
              });
          return
        }

        let destFilePath = uploadFile = presignedRequest.data.FileUploadURL.split('?')[0]
        this.directory.Logo = destFilePath

      },
      //step4
      checkHasDesc(code){
        return this.directory.Text[code] && this.directory.Text[code].length > 0
      },
      clickEditTab(step) {
        WizardForm.r.goTo(step);
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/directory/list/Directories.vue